module.exports = __webpack_public_path__ + "img/gkPcNotePad.ee716c96.jpg";